import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_INSTAGRAM_URL = defineFcm('psf_share_instagram_url')
	.asString()
	.withDefault('https://www.instagram.com/')
	.toConfig();
